import { SiteMenuModel } from './../dtos/site-menu.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CustomizationRequestDto } from '../dtos/customization-request.model';

@Injectable()
export class CustomizationService {
    public newCustomizationAdded: Subject<any>;
    public newDisplayOptionValueAdded: Subject<any>;
    public displayOptionSaved: Subject<any>;
    public displayOptionDSMDSaved: Subject<any>;
    public customizationRequestSelected: Subject<{customizationRequestId, customizationRequestOptionId, context, customizationEntryId, update}>;
    constructor(private apiService: ApiService,
       private router: Router) {
        this.newCustomizationAdded = new Subject<any>();
        this.newDisplayOptionValueAdded = new Subject<any>();
        this.displayOptionSaved = new Subject<any>();
        this.displayOptionDSMDSaved = new Subject<any>();
        this.customizationRequestSelected = new Subject<{customizationRequestId, customizationRequestOptionId, context, customizationEntryId, update}>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */

    getCustomization(id: number): Observable<ApiResponse<CustomizationRequestDto>> {
        return this.apiService.get<CustomizationRequestDto>(`customizationrequest/${id}`);
    }

    getCustomizations(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`customizationrequest`, params);
    }

    getUiElements(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`customizationrequest/ui-elements`, params);
    }

    saveCustomization(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.post<ApiResponse<any>>(`customizationrequest`, params);
    }

    saveDisplayOption(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.post<ApiResponse<any>>(`customizationrequest/add-display-option`, params);
    }

    getCustomizationDisplayOptionsValue(id: number): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/${id}/display-options-values`);
    }

    getCustomizationDisplayOption(id: number): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/${id}/display-option`);
    }

    getCustomizationDisplayOptionValue(id: number): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/${id}/display-option-value`);
    }

    saveDisplayOptionValue(params?: any): Observable<ApiResponse<any>> {
        console.log('params', params)
        return this.apiService.post<ApiResponse<any>>(`customizationrequest/add-display-option-value`, params);
    }

    deleteDisplayOption(id: number): Observable<any> {
        return this.apiService.delete<any>(`customizationrequest/${id}/display-option`);
    }

    deleteDisplayOptionValue(id: number): Observable<any> {
        return this.apiService.delete<any>(`customizationrequest/${id}/display-option-value`);
    }

    getLookupCustomizations(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`customizationrequest/lookup/customizations`, params);
    }

    saveCustomizationCopy(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.post<ApiResponse<any>>(`customizationrequest/copy`, params);
    }

    getAllCustomizationDisplayOptions(params): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/display-options`, params);
    }

    getDsMasters(params): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/dsmaster`, params);
    }

    getDsDetails(params): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/dsdetails`, params);
    }

    getDisplayOptionDsmdItem(id: number): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/datapoint/item/${id}`);
    }

    saveDisplayOptionDsmdItem(params?: any): Observable<ApiResponse<any>> {
        console.log('params', params)
        return this.apiService.post<ApiResponse<any>>(`customizationrequest/datapoint`, params);
    }

    deleteDisplayOptionDsmdItem(id: number): Observable<any> {
        return this.apiService.delete<any>(`customizationrequest/datapoint/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/customization.service.ts